<template>
    <div class="product">

    </div>
</template>

<script>
export default {
    name: 'dynamicProduct',
    data: () => ({

    }),
    props: [
        'product',
        'publications',
        'state',
        'grade',
        'subject',
        'language',
        'version',
        'productDescription',
    ],
    components: {
        Navbar,
        Footer
    },
    computed: {
        ...mapState({
            products: state => _.orderBy(state.cart.products, 'grade'),
            stateData: state => state.stateData.stateData,
            publicationResources: state => state.stateData.publicationResources,
            selectedState: state => state.stateData.selectedState,
            multiyear: state => state.cart.multiyear,
            bundle_dismissed_items: state => state.cart.bundle_dismissed_items
        }),
        ...mapGetters({isHomeschoolStore: 'isHomeschoolStore'}),
        freeVersion () {
            for(let p of this.stateData.publications) {
                if(p.sample_of_id == this.product.id)
                    return p
            }
            return false
        },
        multiyear_selected: {
            get () {
                return this.multiyear
            },
            set (multiyear_selected) {
                this.$store.commit('setMultiyearValue', multiyear_selected)
            }
        },
        selected_multiyear_value () {

            var selected_multiyear_value = 1

            if(!this.multiyear) {
                //this.multiyear = multiyear_options[0]
                this.$store.commit('setMultiyearValue', multiyear_options[0])

            }
            else {
                selected_multiyear_value = this.multiyear
            }

            return selected_multiyear_value
        },
        is_bundle_or_match_dismissed() {
            var status = false
            var bundle_status
            var matching_product
            var matching_product_status

            if(this.bundle_dismissed_items) {
                // //Get This Product Status
                bundle_status = this.bundle_dismissed_items[this.state + '-' + this.product.topic]

                // //Get Matching Status
                matching_product = this.getMatchingProduct(this.product.topic, this.grade, this.language)

                matching_product_status = this.bundle_dismissed_items[this.state + '-' + matching_product.topic]

                if(bundle_status == 1 || bundle_status == 2) {
                    status = true
                }

                if(matching_product_status == 1 || matching_product_status == 2) {
                    status = true
                }
            }

            return status
        },
        suggestedSubject() {
            if(this.subject == 'social-studies' || this.subject == 'national-social-studies') {
                return 'science'
            }
            if(this.subject == 'science') {
                // There should be a publication list in stateData.  Loop through to find if there's a 
                // new social studies for this state/grade.  This is an example, I don't know the
                // actual data structure
                let subject = 'social-studies'
                for(let publication of this.stateData.publications) {
                    if(publication.topic == 'National Social Studies' && publication.grade == this.grade){
                        subject = 'national-social-studies'
                    }
                }
                return subject
            }
        },
        suggestedSubjectName() {
            if(this.suggestedSubject == 'science') { return 'Science' }
            return 'Social Studies'
        },
        product_formats () {
            if(!product_formats) return []

            if(this.product.availability == 'online'){
                return _.filter(product_formats, {value: 'online_only'})
            }
            if(this.product.availability == 'print'){
                return _.filter(product_formats, {value: 'print_online'})
            }
            if(this.product.availability == 'unavailable'){
                return []
            }

            return product_formats
        },
        groupedProducts () {
            return _.orderBy(this.product.grouped_products, ['product_group_order'],['asc'])
        },
        productCover () {
            let productCover = null

            let sku = null

            if (this.product.sku) {
                let sku2 = this.product.sku.replace(/-(?:SS|SN)-(?:EN|ES)-V[0-9]{1,2}/, "")
                sku2 = sku2.replace(/V[0-9]{2}/, "")
                sku = this.product.sku.replace(/V[0-9]{2}/, "")

                productCover = 'store/products/sku/' + sku + '/OStore-' + sku2 + '-SE-Week1-Page1.jpg'
            }

            return productCover
        },
        formattedState () {
            let formattedState = null

            _.forEach(this.states, state => {
                if (
                    this.product.state &&
                    this.product.state == state.state
                ) {
                    formattedState = state.fullState
                }
            })

            return formattedState
        },
        formattedTopic () {
            let subject = null

            if (this.product.topic) {
                // remove hyphens from subject
                subject  = this.product.topic.replace(/-/g, " ")

                // title case subject
                subject = this.titleCase(subject)
                if(subject == "Well Being") subject = "Well-Being"
            }

            return subject
        },
        languages () {
            let languages = []

            // _.filter(this.stateData.publications, publication => {
            //     if (
            //         publication.language &&
            //         publication.topic == this.formattedTopic
            //     ) {
            //         languages.push(publication.language)
            //     }
            // })

            // only show language dropdown if publication with the selected grade has it available
            _.filter(this.stateData.publications, publication => {
                if (
                    publication.grade == this.grade &&
                    publication.topic == this.formattedTopic
                ) {
                    languages.push(publication.language)
                }
            })

            if (languages) {
                return _.uniq(languages)
            }
        },
        product_prices () {
            return this.product.prices
        },
        selected_format_product_prices () {
            if (
                this.format &&
                this.type &&
                this.product_prices
            ) {
                let option
                let format_prices = []

                for (option of this.multiyear_options) {

                    if (this.format == 'online_only') {
                        if (this.quantity > 9 && !this.isHomeschoolStore) {
                            if (this.product.prices[option.value]) {
                                format_prices[option.value] = {
                                    yearstotal: this.product.prices[option.value].online_only_yearstotal,
                                    singleprice: this.product.prices[option.value].online_only_singleprice
                                }
                            }
                        } else {
                            if(this.product.prices[option.value]) {
                                format_prices[option.value] = {
                                    yearstotal: this.product.prices[option.value].online_only_2_yearstotal,
                                    singleprice: this.product.prices[option.value].online_only_2_singleprice
                                }
                            }
                        }
                    }
                    else if (this.format == 'print_online') {
                        if(this.quantity > 9 && !this.isHomeschoolStore) {
                            if(this.product.prices[option.value]) {
                                format_prices[option.value] = {
                                    yearstotal: this.product.prices[option.value].print_online_yearstotal,
                                    singleprice: this.product.prices[option.value].print_online_singleprice
                                }
                            }
                        }
                        else {
                            if(this.product.prices[option.value]) {
                                format_prices[option.value] = {
                                    yearstotal: this.product.prices[option.value].print_online_2_yearstotal,
                                    singleprice: this.product.prices[option.value].print_online_2_singleprice
                                }
                            }
                        }
                    }
                }

                return format_prices
            }
        },
        price_online() {
            if (this.quantity >= 10 && !this.isHomeschoolStore)
                return this.product_prices[1].online_only_singleprice;
            return this.product_prices[1].online_only_2_singleprice;
        },
        set_price() {
            if (this.quantity >= 10 && !this.isHomeschoolStore)
                return this.product_prices[1].print_online_singleprice;
            return this.product_prices[1].print_online_2_singleprice;
        },
        price () {
            if (
                this.format &&
                this.type &&
                this.product_prices[this.selected_multiyear_value]
            ) {
                if (this.format == 'online_only') {
                    return this.product_prices[this.selected_multiyear_value].online_only_yearstotal
                }
                if (
                    this.type == 'classroom' &&
                    this.quantity >= 10
                ) {
                    return this.product_prices[this.selected_multiyear_value].print_online_yearstotal
                }
                if (
                    this.type == 'classroom' &&
                    this.quantity < 10
                ) {
                    return this.product_prices[this.selected_multiyear_value].print_online_2_yearstotal
                }
            }
        },
        price_single () {
            if(this.freeVersion && this.selectedVersion == 'free'){
                return 0;
            }
            if (
                this.format &&
                this.type &&
                this.product_prices[this.selected_multiyear_value]
            ) {
                if (this.format == 'online_only' && this.quantity >= 10 && !this.isHomeschoolStore) {
                    return this.product_prices[this.selected_multiyear_value].online_only_singleprice
                }
                if (this.format == 'online_only') {
                    return this.product_prices[this.selected_multiyear_value].online_only_2_singleprice
                }
                if (
                    this.type == 'classroom' &&
                    this.quantity >= 10 && !this.isHomeschoolStore
                ) {

                    return this.product_prices[this.selected_multiyear_value].print_online_singleprice
                }
                if (
                    this.type == 'classroom'
                ) {
                    return this.product_prices[this.selected_multiyear_value].print_online_2_singleprice
                }
            }
        },
        price_multiyear () {
            return this.price_single * this.selected_multiyear_value
        },
        price_best () {

            var option

            var best = {
                price: 10000000,
                year_amount: 1
            }

            for (option of multiyear_options) {
                if (this.format == 'online_only') {
                    if(this.product.prices[option.value].online_only_singleprice <= best.price) {
                        best.price = this.product_prices[option.value].online_only_singleprice
                        best.year_amount = this.product_prices[option.value].multi_years
                    }
                }
                else if (this.quantity >= 10) {
                    if(this.product.prices[option.value].print_online_singleprice <= best.price) {
                        best.price = this.product.prices[option.value].print_online_singleprice
                        best.year_amount = this.product_prices[option.value].multi_years
                    }
                }
                else if (this.quantity < 10) {
                    if(this.product.prices[option.value].print_online_2_singleprice <= best.price) {
                        best.price = this.product.prices[option.value].print_online_2_singleprice
                        best.year_amount = this.product_prices[option.value].multi_years
                    }
                }
            }

            return best
        },
        minQuantity () {
            if (this.isHomeschoolStore || this.product.topic == 'Character Education')
                return 1;

            return 10

        },
        teacherOptions () {
            return ([...Array(Math.floor((this.quantity-1)/25)+1).keys()].map(x => parseInt(x)+1))
        },
        productWithDifferentFormatAlreadyInCart () {
            let productWithDifferentFormatAlreadyInCart = false
            _.filter(this.products, product => {
                if (
                    product.sku == this.product.sku &&
                    (product.format && product.format !== this.format)
                ) {
                    productWithDifferentFormatAlreadyInCart = true
                }
            })
            return productWithDifferentFormatAlreadyInCart
        },
        productWithNoPrice () {
            let productWithNoPrice = false
            if(this.price > 0) {
                //Price is Good
            }
            else {
                productWithNoPrice = true
            }
            return productWithNoPrice
        }
    },
    watch: {
        'product': {
            handler (product) {

                let grade = null

                _.forEach(this.publications, publication => {
                    if (publication.front_visible) {
                        grade = publication.grade

                        return false
                    }
                })

                if (
                    !product.front_visible &&
                    grade
                ) {
                    this.$router.push({
                        name: this.subject,
                        params: {
                            state: this.state,
                            grade: grade,
                            language: this.language
                        }
                    })
                }

                if (
                    this.language &&
                    !_.find(this.publications, {language: this.language})
                ) {
                    this.$router.push({
                        name: this.subject,
                        params: {
                            state: this.state,
                            grade: this.grade,
                            language: 'en'
                        }
                    })
                }

                this.setDefaults()

            },
            deep: true,
            immediate: true
        },
        'language': {
            handler (language) {
                if (language) {
                    this.lang = this.language
                }
            },
            deep: true,
            immediate: true
        },
        'format': {
            handler (format) {
                if (format == 'online_only' && this.quantity < 10) {

                    //this.quantity = 10

                }
            },
            deep: true,
            immediate: true
        },
        'quantity': {
            handler (quantity) {
                this.checkIfValidQuantityForProduct()
            },
            deep: true,
            immediate: true
        },
        'selectedVersion': {
            handler (selectedVersion) {
                this.checkIfValidQuantityForProduct()
            },
            deep: true,
            immediate: true
        },
        // 'selected_multiyear_value': {
        //     handler (selected_multiyear_value) {
        //         if (selected_multiyear_value > 1 && this.quantity < 10) {
        //             this.quantity = 10

        //             this.allowAddToCart = true
        //         }
        //         else
        //         {
        //             this.allowAddToCart = false
        //         }
        //     },
        //     deep: true,
        //     immediate: true
        // },
        teacherOptions (teacherOptions) {
            if (teacherOptions) {
                let maxTeachers = Math.max.apply(Math, teacherOptions)

                this.teachers = maxTeachers
            }
        },
    },
    methods: {
        setDefaults () {
            if (this.product.burrito || this.isHomeschoolStore) {
                this.quantity = 1
            }
            if(this.product.discontinued == 1 || this.product.availability == 'online') {
                this.format = 'online_only'
            }else{
                this.format = 'print_online'
            }

            // TMP - move to a prop (default quantity / minimum quantity)
            if (this.product.topic == 'Character Education')
                this.quantity = 1;
        },
        addProductToCart () {
            if (this.price == 0) {
                //Do Nothing

                this.$swal({
                    title: "Could not add item to cart",
                    html: "...",
                    type: 'error',
                })
            }
            else if (this.productWithDifferentFormatAlreadyInCart) {
                /*
                    If product is already in the cart with a different fromat and the button is not disabled for some reason,
                    prompt user that the product could not be added to the cart
                */
                this.$swal({
                    title: "Could not add item to cart",
                    html: "This product is already in your cart with a different format. Please first remove the conflicting item from the cart, or add more of the same format.",
                    type: 'error',
                })
            } else {
                /*
                    if product is not already in the cart (with a different format),
                    add product to cart
                */
                this.addingProductToCart = true

                setTimeout(() => {
                    this.addingProductToCart = false
                },1000)

                // console.log(this.freeVersion, this.product);

                let product;

                if (this.freeVersion && this.selectedVersion == 'free'){
                    product = _.cloneDeep(this.freeVersion)
                } else{
                    product = _.cloneDeep(this.product)
                }

                if (this.quantity && !product.quantity || this.quantity != product.quantity) { this.$set(product, 'quantity', this.quantity) }

                if (this.grade || this.grade == '0') {
                    if (!product.cover) { this.$set(product, 'cover', this.productCover) }
                    if (!product.grade) { this.$set(product, 'grade', this.grade) }
                    if (this.type && !product.type) { this.$set(product, 'type', this.type) }
                    if (this.format && !product.format) { this.$set(product, 'format', (this.freeVersion && this.selectedVersion == 'free' ? 'online_only' : this.format)) }
                    if (this.teachers && !product.teachers) { this.$set(product, 'teachers', this.teachers) }
                }

                //Burrito products don't have a title, but have a name.
                if (!product.title) { this.$set(product, 'title', product.name) }

                if (this.multiyear && this.selected_multiyear_value && !product.multiyear) {
                    this.$set(product, 'multiyear', this.selected_multiyear_value)
                }

                // if (this.type && !product.type) { this.$set(product, 'type', this.type) }
                // if (this.format && !product.format) { this.$set(product, 'format', this.format) }
                // if (this.teachers && !product.teachers) { this.$set(product, 'teachers', this.teachers) }

                this.$store.dispatch('addItem', product)

                let productsText = 'products'

                if (this.quantity < 1) {
                    productsText = 'product'
                }
                else {
                    productsText = 'products'
                }

                this.$swal({
                        toast: true,
                        html: this.quantity + ' ' + productsText + ' added to cart.',
                        type: 'success',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 2500
                })

                if(this.quantity >= 10) {
                    this.doProductBundleOfferPopup()
                }
            }
        },
        getMatchingProduct(current_topic, current_grade, current_language) {
            let new_topic
            let new_bundle_publication
            let new_bundle_product = {}

            if(current_topic == 'Social Studies' || current_topic == 'National Social Studies') {
                new_topic = 'Science'
            }
            else {
                new_topic = 'Social Studies'
            }

            _.forEach(this.stateData.publications, publication => {
                if (publication.topic == new_topic && publication.grade == current_grade && publication.language == current_language) {
                    new_bundle_publication = publication
                }
            })

            new_bundle_publication.multiyear = this.multiyear_selected.value

            new_bundle_publication.quantity = this.quantity
            new_bundle_publication.format = this.format
            new_bundle_publication.type = this.type
            new_bundle_publication.teachers = this.teachers

            new_bundle_publication.cover = this.productCover_BundleProduct(new_bundle_publication.sku)

            return new_bundle_publication
        },
        addProductToCart_BundleProduct () {
            if (this.price == 0) {
                //Do Nothing

                this.$swal({
                    title: "Could not add item to cart",
                    html: "...",
                    type: 'error',
                })
            }
            else if (this.productWithDifferentFormatAlreadyInCart) {
                /*
                    If product is already in the cart with a different fromat and the button is not disabled for some reason,
                    prompt user that the product could not be added to the cart
                */
                this.$swal({
                    title: "Could not add item to cart",
                    html: "This product is already in your cart with a different format. Please first remove the conflicting item from the cart, or add more of the same format.",
                    type: 'error',
                })
            } else {
                /*
                    if product is not already in the cart (with a different format),
                    add product to cart
                */
                this.addingBundleProductToCart = true

                setTimeout(() => {
                    this.addingBundleProductToCart = false

                    this.$bvModal.hide('bundle-product-modal')
                },1000)

                // console.log(this.freeVersion, this.product);

                let bundle_product = _.cloneDeep(this.getMatchingProduct(this.product.topic, this.grade, this.language))

                if (this.grade || this.grade == '0') {
                    // if (!bundle_product.cover) { this.$set(bundle_product, 'cover', this.productCover) }
                    // if (!bundle_product.grade) { this.$set(bundle_product, 'grade', this.grade) }
                    // if (this.type && !bundle_product.type) { this.$set(bundle_product, 'type', this.type) }
                    if (this.format && !bundle_product.format) { this.$set(bundle_product, 'format', (this.freeVersion && this.selectedVersion == 'free' ? 'online_only' : this.format)) }
                    // if (this.teachers && !bundle_product.teachers) { this.$set(bundle_product, 'teachers', this.teachers) }
                }

                //Burrito products don't have a title, but have a name.
                // if (!bundle_product.title) { this.$set(bundle_product, 'title', bundle_product.name) }

                // if (this.type && !bundle_product.type) { this.$set(bundle_product, 'type', this.type) }
                // if (this.format && !bundle_product.format) { this.$set(bundle_product, 'format', this.format) }
                // if (this.teachers && !bundle_product.teachers) { this.$set(bundle_product, 'teachers', this.teachers) }

                this.$store.dispatch('addItem', bundle_product)

                this.$swal({
                        toast: true,
                        html: bundle_product.quantity + ' products added to cart.',
                        type: 'success',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 2500
                })

                this.setProductBundleAdded(this.product)
                this.setProductBundleAdded(bundle_product)
            }
        },
        doProductBundleOfferPopup() {
            if (this.isHomeschoolStore)
                return;


            if(!this.is_bundle_or_match_dismissed && this.isDiscountAllowedForCurrentState() == true) {
                if(this.product.topic == 'Social Studies' || this.product.topic == 'National Social Studies' || this.product.topic == 'Science') {
                    this.displayProductBundleOffer = true

                    this.$bvModal.show('bundle-product-modal')
                    this.$store.dispatch('bundleOffered', 'bundle2')
                }
            }
        },
        resetProductBundlePopup() {
            this.displayProductBundleOffer = false
        },
        showImageModal (source) {
            this.selectImage(source)

            this.$bvModal.show("image-modal")
        },
        closeImageModal () {
            this.$bvModal.hide("image-modal")
        },
        selectImage (source) {
            this.selectedImage = source
        },
        // misc utility methods
        changeLanguage (language) {
            this.$router.push({
                name: this.subject,
                params: {
                    state: this.state,
                    grade: this.grade,
                    subject: this.subject,
                    language: language
                }
            })
        },
        titleCase (string) {
            let splitString = string.toLowerCase().split(' ')

            for (let i = 0; i < splitString.length; i++) {
                splitString[i] = splitString[i].charAt(0).toUpperCase() + splitString[i].substring(1)
            }

            return splitString.join(' ')
        },
        setProductBarPadding () {
            let height = null

            if (this.$refs.productBar) {
                height = this.$refs.productBar.clientHeight

                document.querySelector(".footer").setAttribute("Style", "padding-bottom:" + height + "px;");
            }
        },
        setProductBundleDismissedValue(value) {
            let bundle_product = _.cloneDeep(this.getMatchingProduct(this.product.topic, this.grade, this.language))

            let identifier = this.product.state + '-' + this.product.topic
            let bundle_identifier = this.product.state + '-' + bundle_product.topic

            //Dismiss This Product
            this.$store.commit('setProductBundleDismissed', {product_identifier:identifier, value:value})

            //Dismiss Other Product
            this.$store.commit('setProductBundleDismissed', {product_identifier:bundle_identifier, value:value})

            this.displayProductBundleOffer = false

            this.$nextTick(() => {
                //console.log(this.bundle_dismissed_items)
            })

            this.hideBundleDiscountModal()
        },
        setProductBundleAdded(this_product) {
            this.setProductBundleDismissedValue(2)
        },
        setProductBundleDismissed() {
            this.setProductBundleDismissedValue(1)
        },
        productCover_BundleProduct (sku) {
            let productCover = null

            if (sku) {
                let sku2 = this.product.sku.replace(/-(?:SS|SN)-EN-V[0-9]{1,2}/, "")
                sku2 = sku2.replace(/V[0-9]{2}/, "")
                sku = sku.replace(/V[0-9]{2}/, "")

                productCover = 'store/products/sku/' + sku + '/OStore-' + sku2 + '-SE-Week1-Page1.jpg'
            }

            return productCover
        },
        checkIfValidQuantityForProduct() {
            if(this.selected_multiyear_value > 1 && this.quantity < 10 && !this.product.burrito) {
                this.limitQuantityForMultiyear = true
            }
            else {
                this.limitQuantityForMultiyear = false
            }

            if (this.quantity < 10 && !this.product.burrito) {
                this.$store.commit('setMultiyearValue', multiyear_options[0])

                this.multiyear_options = [{
                    value: '1',
                    label: '1 Year Subscription'
                }]
            }
            else {
                this.multiyear_options = [...multiyear_options]
            }

            if (this.quantity < 10 && this.format == 'online_only') {
                // this.quantity = 10
                this.allowAddToCart = true
            }
            else if (this.quantity < 10 && this.selected_multiyear_value > 1 && !this.product.burrito) {
                // this.quantity = 10
                this.allowAddToCart = false
            }
            // else if (this.quantity < 10 && (this.product.topic == 'Well Being' || this.product.topic == 'Well-Being') && this.selectedVersion == 'full') {
                // this.allowAddToCart = false
            // }
            else
            {
               this.allowAddToCart = true
            }
        },
        hideBundleDiscountModal () {
            this.$bvModal.hide('bundle-product-modal')
        },
        resetProductBundleDismissedValues () {
            this.$store.commit('resetProductBundleDismissed')
        },
        isDiscountAllowedForCurrentState () {
            if(states_disallow_discount_codes.includes(this.state) == true) {
                return false
            }
            else {
                return true
            }
        }
    },
    mounted () {
        if (this.language) {
            this.productLanguage = this.language
        }



        //this.$store.commit('resetProductBundleDismissed')

        window.addEventListener('resize', this.setProductBarPadding)

        this.setProductBarPadding()

        this.setDefaults()

        window.scrollTo(0,0);
    }
}
</script>

<style>

</style>